import React from "react";
import {
  Pill,
  Dot,
  type StatusVariant,
  type StatusPillSize,
  type StatusPillAppearance,
} from "./StatusPill.styles";

export interface StatusPillProps {
  variant?: StatusVariant;
  /** `md` uses caption-3 (default). `sm` uses overline-3. `chip` is a compact tonal chip (22px, uppercase). */
  size?: StatusPillSize;
  /** Filled (default), outline, soft, or `dot` (a coloured dot and word, no chip). */
  appearance?: StatusPillAppearance;
  /** Whether to show the leading coloured dot (default true). */
  showDot?: boolean;
  /** Forwarded to the root element — lets callers extend this component with `styled(StatusPill)`. */
  className?: string;
  children: React.ReactNode;
}

const StatusPill: React.FC<StatusPillProps> = ({
  variant = "neutral",
  size = "md",
  appearance = "filled",
  showDot = true,
  className,
  children,
}) => (
  <Pill className={className} $variant={variant} $size={size} $appearance={appearance}>
    {showDot && <Dot $size={size} />}
    {children}
  </Pill>
);

export default StatusPill;
export type {
  StatusVariant,
  StatusPillSize,
  StatusPillAppearance,
} from "./StatusPill.styles";
